export const SET_INTERCOM_SETTINGS = 'SET_INTERCOM_SETTINGS'
export const STOP_INTERCOM_CHAT = 'STOP_INTERCOM_CHAT'
export const MARK_INTERCOM_TESTER_REQUESTED = 'MARK_INTERCOM_TESTER_REQUESTED'
